import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, Event, ActivationEnd, RoutesRecognized, NavigationEnd } from '@angular/router';
import { LogsSessionService } from './core/services/logs-session.service';
import { filter, map } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { UserProfileService } from './core/services/user.service';
import { IdleService } from './core/services/idle.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { LogsService } from './core/services/logs.service';
import { detectBrowserName, Decrypt , Encrypt  } from './pages/functions/functions';
import { SettingsService } from 'src/app/core/services/settings.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationsService } from './core/services/notifications.service';
import { ToastsService } from './core/services/toasts.service';
import { Usuario } from './core/models/usuario.model';
import { MantenimientosService } from './core/services/mantenimientos.service';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';
import { EventosService } from './core/services/eventos.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements  OnInit,OnDestroy  {
  titulo:string = '';
  tituloSubs$:Subscription;
  currentRoute: string;
  url:string = '';
  public usuario: Usuario;
  constructor(private router:Router,private route:ActivatedRoute,
    private logservice:LogsSessionService,
    private usuerService:UserProfileService, 
    private idleService: IdleService,private logService:LogsService,
    private settingsService:SettingsService,
    private modalService: NgbModal,
    private notificationsService:NotificationsService,
    private toastsService:ToastsService,
    public toastr: ToastrService,
    private mantenimientosService:MantenimientosService,
    private eventosService:EventosService) {
    // this.tituloSubs$ = this.getArgumentosRuta()
    // .subscribe( ({titulo}) =>{ return titulo; });
   
  }

   ngOnInit() {
    this.settingsService.getSettingsFilter();
    // this.settingsService.getSettings();
   
   this.router.events.pipe(filter(event => event instanceof RoutesRecognized))
    .subscribe(async(event) => {
    
      localStorage.setItem('rout',Encrypt(event['url'.toString()]));
      let data = {
        access: await this.getArgumentosRuta(),
        move:"Navegacion",
        observation:event['url'],
        user_id:localStorage.getItem('key_id') ? Decrypt(localStorage.getItem('key_id').toString()) : ''
      }

      if(localStorage.getItem('token')){
        this.getAutorizations();
      }

       this.logservice.postLogs_Sessions(data).subscribe(resp =>{
        //  console.log(resp);
       })

    });


 

    if(localStorage.getItem('token')){
    
      setInterval(async () => {
       await  this.alarmaError();
      }, 20000);

      this.initialIdleSettings();
      setInterval(async()=>{
       await  this.getAlertsMant();
        
        // this.getVigencia();
      },5000)
    }
  }


  separateURL(){
    let urlactual  = document.location.href;

  let divid = urlactual.split('/');
  return divid[4];
  }

  async  initialIdleSettings() {
    let geoip:any =  await this.usuerService.geoip;
    let publicip:any = await this.usuerService.publicip;
    let timeseconds:number  = 10;

    const idleTimeoutInSeconds: number = timeseconds * 60;
    this.idleService.startWatching(idleTimeoutInSeconds).subscribe((isTimeOut: boolean) => {

      if (isTimeOut) {
      
            Swal.fire(
              'Adios!',
              'La sesión ha sido cerrada por inactividad',
              'warning'
            )
            this.modalService.dismissAll();
            this.usuerService.logout();
            this.router.navigateByUrl('/account/login');
            let navegator = detectBrowserName();
            let data = {
              user_id:this.usuerService.uid,
              msg:'Cierre de Sesión por Inactividad',
              petition:'POST',
              detail:'Cierre de Sesion por Inactividad',
              register_id:this.usuerService.uid,
              navegator,
              is_login:'0',
              ip_origin:publicip.ip,
              disconnection:'0',
              ipv6:geoip.version,
              ip:geoip.ip,
              network:geoip.network,
              city:geoip.city,
              latitude:geoip.latitude,
              longitude:geoip.longitude,
              region:geoip.region,
              timezone:geoip.timezone,
              postal:geoip.postal,
              status_id:4
            }
            this.savelog(data);
            this.eventosService.bitacora.fechaHoraEvento = moment()
            this.eventosService.bitacora.usuarioresponsable = 'System';
            this.eventosService.bitacora.tiopevento = "5"
            this.eventosService.bitacora.month = moment().format('YYYY-MM')
            this.eventosService.bitacora.descripcionevento = `Cierre de sesión por inactividad ${Decrypt(this.usuerService.usuario.username)} `
           this.eventosService.registrarEventos()
      }
    })
  }
  savelog(data:any){
    // console.log(data);
  this.logService.postLogs(data);
  }


async  getArgumentosRuta(){

    return new Promise(resolve =>{
     this.router.events.subscribe((event:Event) =>{
        // console.log(titulo);
        if (event instanceof NavigationEnd) {
          resolve(this.separar( event.url));


      }
      // console.log(event['url']);
        });
      })
   }

   ngOnDestroy(): void {
     this.tituloSubs$.unsubscribe();
   }

   separar(text){
    let texto = text;
    let name = texto.split('/');

    return name[2];
   }


    getAutorizations(){
   this.notificationsService.getAutorizations().subscribe(async (resp:any) => {
      for (const key in resp) {
          const element = resp[key];

           
          if(Decrypt(localStorage.getItem('profile')) === 'Administrador'){
            if(element.status === false){  
             await this.toastsService.showInfo('Solicitud de autorización',`Tienes unas autorizaciones pendientes, solicitada por ${Decrypt(element.name)} ${Decrypt(element.lastname)}`)
            }
          }else{
       
            if(element.token_client && element.status === true && element.is_used === false && element.user_id_client === Number(Decrypt(localStorage.getItem('key_id')))  && element.is_invalid === false){ 
               await this.toastsService.showInfo('Solicitud de autorización',`Ya fue autorizada la peticion utiliza el token antes de que caduque`)
            }
          }
        
      }
    })
   }

   getAlertsMant(){
    this.mantenimientosService.getMantenimientosAlertas().subscribe((resp:any)=>{
      if(resp.count >= 1 ){
        this.toastsService.showWarning('Alerta',`Tienes ${resp.count} mantenimientos en estado pendiente `)
      }
    })
   }
   getVigencia(){
    this.mantenimientosService.getVigenciaAlertas().subscribe((resp:any)=>{
      // console.log(resp);
      if(resp.ok){
        this.toastsService.showDanger('Alerta',`Tienes Vigencias de calibracion por vencer o vencidas en sistemas de medicion`)
      }
    })
   }

   alarmaError(){
    this.mantenimientosService.getAlarmas().subscribe((resp:any)=>{
      if(resp.ok){
        for (const key in resp.data) {
            const element = resp.data[key];
              this.toastr.error('Error',`${element.tipoEvento} - ${Decrypt(element.descripcionEvento)}`)
        }
      }
    })
    // getAlarmas
  }
}
